import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList, todayDay } from "@/mocks/anime";

export default function TodaySection() {
  const todayItems = animeList.filter((a) => a.day === todayDay);

  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <span className="h-1.5 w-1.5 rounded-full bg-secondary-500"></span>
              今日（{todayDay}）更新
            </span>
            <h2 className="mt-2 text-xl font-bold text-foreground-950 md:text-2xl">
              今天更新了这些，别错过
            </h2>
          </div>
          <Link
            to="/calendar"
            className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看全部日程 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {todayItems.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
          {todayItems.length < 4 &&
            animeList
              .filter((a) => a.day !== todayDay)
              .slice(0, 4 - todayItems.length)
              .map((anime) => <AnimeCard key={anime.id} anime={anime} />)}
        </div>
      </div>
    </section>
  );
}